// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"756":"72326395","928":"89020b67"}[chunkId] + ".chunk.js";
};